<template>
  <div class="footerLink">
    <h3 class="footerLink__title">
      {{ heading }}
    </h3>
    <ul>
      <li
        v-for="link in links"
        :key="link.title"
        class="footerLink__list"
      >
        <router-link
          :to="link.url"
          class="footerLink__list--link"
        >
          {{ link.title }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from 'vue'
interface Link {
  title: string
  url: string
}

export default defineComponent({
  props: {
    heading: {
      type: String as PropType<string>,
      required: true,
    },
    links: {
      type: Array as PropType<Link[]>,
      required: true,
    },
  },
})

</script>

<style lang="scss" scoped>
@import '@/sass/module/components/footer-link-component';
</style>
